var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99931 8.66667V1.33333L13.3326 4L7.99931 6.66667M13.6993 6.82C14.0541 7.91343 14.0873 9.08575 13.7949 10.1975C13.5026 11.3092 12.8971 12.3136 12.0504 13.0911C11.2036 13.8686 10.1514 14.3865 9.0188 14.5832C7.88621 14.7799 6.72096 14.6471 5.66168 14.2006C4.6024 13.7541 3.69368 13.0127 3.04363 12.0646C2.39359 11.1165 2.02958 10.0016 1.99492 8.85262C1.96025 7.7036 2.2564 6.56881 2.84811 5.58326C3.43982 4.5977 4.3022 3.80288 5.33264 3.29333M5.33264 6.66667C4.99858 7.11135 4.78109 7.63255 4.7 8.18279C4.61891 8.73303 4.6768 9.29482 4.86838 9.81697C5.05996 10.3391 5.37914 10.805 5.79686 11.1722C6.21458 11.5395 6.71754 11.7963 7.25993 11.9194C7.80232 12.0425 8.36689 12.028 8.90221 11.8771C9.43752 11.7261 9.92657 11.4437 10.3248 11.0554C10.723 10.6671 11.0177 10.1853 11.1821 9.65402C11.3465 9.12268 11.3753 8.55866 11.266 8.01333",
    stroke: "#18181B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/goal.efee24d22df552ac4ff9887397eb1420.svg";
export { ForwardRef as ReactComponent };